import React, { Component } from "react";
import classes from "./GameOverNotRegistered.module.css";
import { strings } from "constants/strings";
import { analyticsActions } from "constants/analytics-actions-id";

export default class GameOverNotRegistered extends Component {
  render() {
    return (
      <div key="gameOver" className="game-over height-fix">
        <div className="gameOver-inner">
          <h2 
          className={classes.HeaderWell}
          dangerouslySetInnerHTML={{__html: strings.Postexercise_motivation}}
          ></h2>
          {this.props.children && this.props.children}
          {!this.props.children && (
            <>
              <div 
              style={{ fontSize: "22px" }}
              dangerouslySetInnerHTML={{__html: strings.Postexercise_scoretitle}}
              ></div>
              <div className="score">{Math.floor(this.props.points)}</div>
            </>
          )}
          <div style={{ fontSize: "22px", width: "80%", margin: "50px auto 5px" }}>
            {strings.Postexercise_trial_text}
          </div>
          <a id={analyticsActions.WordPairsInitial.btnPremium} href={strings.Web_register_link} style={{ fontSize: "18px" }} className="ex-button yellow get-access-btn">
            {strings.Postexercise_trial_button}
          </a>
        </div>
      </div>
    )}
}
